module.exports = "https://cdn.littlereply.com/tt/resource/question.f7dce84df7bbffaedf8710d692efa4c6.png";